// 百度地图样式1
const baiduMapStyle1 = () => {
  return [
    {
      featureType: "land",
      elementType: "geometry",
      stylers: {
        color: "#0b101fff",
      },
    },
    {
      featureType: "boundary",
      elementType: "geometry",
      stylers: {
        color: "#064f85",
      },
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: {
        weight: "3",
        visibility: "off",
      },
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3a4c54ff",
      },
    },
    {
      featureType: "road",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subwaylabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subwaylabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "tertiarywaysign",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "tertiarywaysign",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "provincialwaysign",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "provincialwaysign",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "nationalwaysign",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "nationalwaysign",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "highwaysign",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "highwaysign",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: {
        color: "#112d4fff",
      },
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: {
        color: "#626a79ff",
      },
    },
    {
      featureType: "water",
      elementType: "labels.text",
      stylers: {
        fontsize: "25",
      },
    },
    {
      featureType: "green",
      elementType: "geometry",
      stylers: {
        color: "#2f4550ff",
        visibility: "off",
      },
    },
    {
      featureType: "scenicspots",
      elementType: "geometry",
      stylers: {
        color: "#586f7cff",
        visibility: "off",
      },
    },
    {
      featureType: "education",
      elementType: "geometry",
      stylers: {
        color: "#31005aff",
        visibility: "off",
      },
    },
    {
      featureType: "transportation",
      elementType: "geometry",
      stylers: {
        color: "#31005aff",
        visibility: "off",
      },
    },
    {
      featureType: "manmade",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        color: "#31005aff",
      },
    },
    {
      featureType: "manmade",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "manmade",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
        weight: 0.5,
      },
    },
    {
      featureType: "scenicspots",
      elementType: "labels.text.fill",
      stylers: {
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry.fill",
      stylers: {
        color: "#710049ff",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry.stroke",
      stylers: {
        color: "#23217000",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        weight: 4,
        visibility: "off",
      },
    },
    {
      featureType: "highway",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,7",
        level: "6",
      },
    },
    {
      featureType: "highway",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,7",
        level: "7",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,7",
        level: "6",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,7",
        level: "7",
      },
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,7",
        level: "6",
      },
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,7",
        level: "7",
      },
    },
    {
      featureType: "highway",
      elementType: "labels.text.stroke",
      stylers: {
        weight: 1,
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry.fill",
      stylers: {
        color: "#710049ff",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry.stroke",
      stylers: {
        color: "#23217000",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        weight: 4,
        visibility: "off",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "6",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "7",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "8",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "9",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "10",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "6",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "7",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "8",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "10",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "6",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "7",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "8",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        curZoomRegionId: "0",
        curZoomRegion: "6,10",
        level: "10",
      },
    },
    {
      featureType: "education",
      elementType: "labels.text",
      stylers: {
        fontsize: 26,
      },
    },
    {
      featureType: "manmade",
      elementType: "labels.text",
      stylers: {
        fontsize: 26,
      },
    },
    {
      featureType: "transportation",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "transportation",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "transportation",
      elementType: "labels.text",
      stylers: {
        fontsize: 26,
      },
    },
    {
      featureType: "scenicspots",
      elementType: "labels.text",
      stylers: {
        fontsize: 26,
      },
    },
    {
      featureType: "scenicspots",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#b8dbd9ff",
      },
    },
    {
      featureType: "building",
      elementType: "geometry.topfill",
      stylers: {
        color: "#3d036eff",
      },
    },
    {
      featureType: "building",
      elementType: "geometry.sidefill",
      stylers: {
        color: "#44027bff",
      },
    },
    {
      featureType: "building",
      elementType: "geometry.stroke",
      stylers: {
        color: "#31005aff",
      },
    },
    {
      featureType: "provincialway",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "provincialway",
      elementType: "geometry.fill",
      stylers: {
        color: "#710049ff",
      },
    },
    {
      featureType: "provincialway",
      elementType: "geometry.stroke",
      stylers: {
        color: "#23217000",
      },
    },
    {
      featureType: "provincialway",
      elementType: "geometry",
      stylers: {
        weight: 4,
        visibility: "off",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry",
      stylers: {
        weight: 2,
        visibility: "off",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry.stroke",
      stylers: {
        color: "#23217000",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry.fill",
      stylers: {
        color: "#710049ff",
      },
    },
    {
      featureType: "arterial",
      elementType: "geometry.fill",
      stylers: {
        color: "#710049ff",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "geometry.fill",
      stylers: {
        color: "#710049ff",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "geometry.fill",
      stylers: {
        color: "#710049ff",
      },
    },
    {
      featureType: "local",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "local",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "arterial",
      elementType: "geometry",
      stylers: {
        weight: 2,
        visibility: "off",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "geometry",
      stylers: {
        weight: 2,
        visibility: "off",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "geometry",
      stylers: {
        weight: 2,
        visibility: "off",
      },
    },
    {
      featureType: "provincialway",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "provincialway",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "arterial",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "arterial",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#00eee0ff",
      },
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
        visibility: "off",
      },
    },
    {
      featureType: "transportationlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "transportationlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "transportationlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "transportationlabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "country",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#6f788aff",
        weight: 40,
      },
    },
    {
      featureType: "country",
      elementType: "labels.text.stroke",
      stylers: {
        weight: 2,
        color: "#ffffff00",
      },
    },
    {
      featureType: "city",
      elementType: "labels.text.fill",
      stylers: {
        color: "#6f788aff",
        weight: 40,
      },
    },
    {
      featureType: "city",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
        weight: 2,
      },
    },
    {
      featureType: "city",
      elementType: "labels.text",
      stylers: {
        fontsize: 26,
      },
    },
    {
      featureType: "country",
      elementType: "labels.text",
      stylers: {
        fontsize: 28,
      },
    },
    {
      featureType: "country",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,9",
        level: "6",
      },
    },
    {
      featureType: "country",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,9",
        level: "7",
      },
    },
    {
      featureType: "country",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,9",
        level: "8",
      },
    },
    {
      featureType: "country",
      stylers: {
        curZoomRegionId: "0",
        curZoomRegion: "6,9",
        level: "9",
      },
    },
    {
      featureType: "country",
      elementType: "labels",
      stylers: {
        visibility: "on",
        curZoomRegionId: "0",
        curZoomRegion: "6,9",
        level: "6",
      },
    },
    {
      featureType: "country",
      elementType: "labels",
      stylers: {
        visibility: "on",
        curZoomRegionId: "0",
        curZoomRegion: "6,9",
        level: "7",
      },
    },
    {
      featureType: "country",
      elementType: "labels",
      stylers: {
        visibility: "on",
        curZoomRegionId: "0",
        curZoomRegion: "6,9",
        level: "8",
      },
    },
    {
      featureType: "country",
      elementType: "labels",
      stylers: {
        visibility: "on",
        curZoomRegionId: "0",
        curZoomRegion: "6,9",
        level: "9",
      },
    },
    {
      featureType: "city",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#626a7900",
      },
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "arterial",
      elementType: "geometry.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "geometry.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "geometry.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "airportlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#00eee0ff",
      },
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
      },
    },
    {
      featureType: "city",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#6f788aff",
        weight: 40,
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
        weight: 2,
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels.text",
      stylers: {
        fontsize: 25,
      },
    },
    {
      featureType: "continent",
      elementType: "labels.text",
      stylers: {
        fontsize: 35,
      },
    },
    {
      featureType: "continent",
      elementType: "labels.text.stroke",
      stylers: {
        weight: 2,
        color: "#ffffff00",
      },
    },
    {
      featureType: "continent",
      elementType: "labels.text.fill",
      stylers: {
        color: "#6f788aff",
      },
    },
    {
      featureType: "poilabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "airportlabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "educationlabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "medicallabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "entertainmentlabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "estatelabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "businesstowerlabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "companylabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "governmentlabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "restaurantlabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "hotellabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "shoppinglabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "lifeservicelabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "carservicelabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "financelabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "INTERNATIONALIZEICONICON",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "INTERNATIONALIZEICONICON",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "financelabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "carservicelabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "lifeservicelabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "shoppinglabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "hotellabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "restaurantlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "governmentlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "companylabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "businesstowerlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "estatelabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "entertainmentlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "medicallabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "educationlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "poilabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "arterial",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "arterial",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "local",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "scenicspotsway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "universityway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "vacationway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "railway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subway",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subway",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "roadarrow",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "footbridge",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "crosswalk",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "underpass",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "parkingspace",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "laneline",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "parkinglot",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "playground",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "transportation",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "shopping",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "estate",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "entertainment",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "scenicspots",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "medical",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "medical",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "education",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subwaystation",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "manmade",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "building",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "island",
      elementType: "labels.text.fill",
      stylers: {
        color: "#6f788aff",
      },
    },
    {
      featureType: "island",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#ffffff00",
        weight: 2,
      },
    },
    {
      featureType: "island",
      elementType: "labels.text",
      stylers: {
        fontsize: 26,
      },
    },
    {
      featureType: "district",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "town",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "village",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
  ];
};

// 百度地图样式2
const baiduMapStyle2 = () => {
  return [
    {
      featureType: "land",
      elementType: "geometry",
      stylers: {
        visibility: "on",
        color: "#0b101fff",
      },
    },
    {
      featureType: "boundary",
      elementType: "geometry",
      stylers: {
        color: "#064f85",
      },
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#626a79ff",
      },
    },
    {
      featureType: "building",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#4d636dff",
      },
    },
    {
      featureType: "building",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3e5154ff",
      },
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: {
        visibility: "on",
        color: "#112d4fff",
      },
    },
    {
      featureType: "village",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "town",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "district",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "country",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#6f788aff",
        weight: 10,
      },
    },
    {
      featureType: "city",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "off",
        color: "#6f788aff",
        weight: 30,
        text: "是否显示城市名字",
      },
    },
    {
      featureType: "continent",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "poilabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "poilabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "transportationlabel",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "transportationlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "airportlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "road",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3a4c54ff",
      },
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: {
        weight: "3",
      },
    },
    {
      featureType: "green",
      elementType: "geometry",
      stylers: {
        visibility: "on",
        color: "#2f4550ff",
      },
    },
    {
      featureType: "scenicspots",
      elementType: "geometry",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "scenicspots",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "scenicspots",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "continent",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "country",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#6f788aff",
        weight: 0,
      },
    },
    {
      featureType: "city",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#6f788a00",
        weight: 0,
      },
    },
    {
      featureType: "city",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "airportlabel",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "transportationlabel",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "railway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "highwaysign",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "nationalwaysign",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "nationalwaysign",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "provincialwaysign",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "provincialwaysign",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "tertiarywaysign",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "tertiarywaysign",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subwaylabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "subwaylabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
        weight: "90",
      },
    },
    {
      featureType: "road",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "shopping",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "scenicspots",
      elementType: "labels",
      stylers: {
        visibility: "on",
      },
    },
    {
      featureType: "scenicspotslabel",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "manmade",
      elementType: "geometry",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "manmade",
      elementType: "labels",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "highwaysign",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#626a7900",
      },
    },
    {
      featureType: "road",
      stylers: {
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      stylers: {
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      stylers: {
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      stylers: {
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "road",
      elementType: "labels.text",
      stylers: {
        fontsize: "24",
      },
    },
    {
      featureType: "highway",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry.stroke",
      stylers: {
        color: "#1c4f7eff",
      },
    },
    {
      featureType: "highway",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        weight: "3",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry.stroke",
      stylers: {
        color: "#1c4f7eff",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        weight: "3",
      },
    },
    {
      featureType: "provincialway",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "arterial",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "local",
      elementType: "geometry.fill",
      stylers: {
        visibility: "on",
        color: "#586f7cff",
      },
    },
    {
      featureType: "provincialway",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3a4c54ff",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3a4c54ff",
      },
    },
    {
      featureType: "arterial",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3a4c54ff",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3a4c54ff",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3a4c54ff",
      },
    },
    {
      featureType: "local",
      elementType: "geometry.stroke",
      stylers: {
        visibility: "on",
        color: "#3a4c54ff",
      },
    },
    {
      featureType: "local",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "local",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "arterial",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "provincialway",
      elementType: "labels.text.fill",
      stylers: {
        visibility: "on",
        color: "#f4f4f9ff",
      },
    },
    {
      featureType: "provincialway",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "arterial",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "labels.text.stroke",
      stylers: {
        visibility: "on",
        color: "#b8dbd9ff",
        weight: "1",
      },
    },
    {
      featureType: "fourlevelway",
      elementType: "geometry",
      stylers: {
        weight: "1",
      },
    },
    {
      featureType: "tertiaryway",
      elementType: "geometry",
      stylers: {
        weight: "1",
      },
    },
    {
      featureType: "local",
      elementType: "geometry",
      stylers: {
        weight: "1",
      },
    },
    {
      featureType: "provincialway",
      elementType: "geometry",
      stylers: {
        weight: "3",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry",
      stylers: {
        weight: "3",
      },
    },
    {
      featureType: "arterial",
      elementType: "geometry",
      stylers: {
        weight: "3",
      },
    },
    {
      featureType: "highway",
      stylers: {
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      stylers: {
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      stylers: {
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      stylers: {
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "highway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      stylers: {
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "nationalway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "provincialway",
      stylers: {
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "8-10",
      },
    },
    {
      featureType: "provincialway",
      stylers: {
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "8-10",
      },
    },
    {
      featureType: "provincialway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "8-10",
      },
    },
    {
      featureType: "provincialway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "8-10",
      },
    },
    {
      featureType: "provincialway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "8-10",
      },
    },
    {
      featureType: "provincialway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "8-10",
      },
    },
    {
      featureType: "cityhighway",
      stylers: {
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      stylers: {
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      stylers: {
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      stylers: {
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "6",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "7",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "8",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "cityhighway",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "6-9",
      },
    },
    {
      featureType: "arterial",
      stylers: {
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "9-9",
      },
    },
    {
      featureType: "arterial",
      elementType: "geometry",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "9-9",
      },
    },
    {
      featureType: "arterial",
      elementType: "labels",
      stylers: {
        visibility: "off",
        level: "9",
        curZoomRegionId: "0",
        curZoomRegion: "9-9",
      },
    },
    {
      featureType: "background",
      elementType: "geometry",
      stylers: {
        visibility: "on",
      },
    },
    {
      featureType: "water",
      elementType: "labels.text",
      stylers: {
        fontsize: "25",
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels.text.fill",
      stylers: {
        color: "#6f788aff",
        weight: 30,
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels.text.stroke",
      stylers: {
        color: "#6f788a00",
        weight: 0,
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels.text",
      stylers: {
        fontsize: 28,
      },
    },
    {
      featureType: "districtlabel",
      elementType: "labels.icon",
      stylers: {
        visibility: "off",
      },
    },
    {
      featureType: "country",
      elementType: "labels.text",
      stylers: {
        fontsize: "25",
      },
    },
    {
      featureType: "city",
      elementType: "labels.text",
      stylers: {
        fontsize: 35,
      },
    },
  ];
};

// 百度地图中散点图片1
const blueBase = () => {
  return "image://data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxOS4yMDkiIHZpZXdCb3g9IjAgMCAxNiAxOS4yMDkiPg0KICA8ZGVmcz4NCiAgICA8c3R5bGU+DQogICAgICAuY2xzLTEsIC5jbHMtMiwgLmNscy0zIHsNCiAgICAgICAgZmlsbDogIzM0OGJlNzsNCiAgICAgIH0NCg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgb3BhY2l0eTogMC4yOw0KICAgICAgfQ0KDQogICAgICAuY2xzLTIgew0KICAgICAgICBvcGFjaXR5OiAwLjU7DQogICAgICB9DQogICAgPC9zdHlsZT4NCiAgPC9kZWZzPg0KICA8ZyBpZD0i57uEXzQ3ODAiIGRhdGEtbmFtZT0i57uEIDQ3ODAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTk0LjYzOSAtNjAzLjc5MikiPg0KICAgIDxnIGlkPSLnu4RfMzkwOCIgZGF0YS1uYW1lPSLnu4QgMzkwOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTE5NSA2MTkuMTgzKSI+DQogICAgICA8ZWxsaXBzZSBpZD0i5qSt5ZyGXzY1NiIgZGF0YS1uYW1lPSLmpK3lnIYgNjU2IiBjbGFzcz0iY2xzLTEiIGN4PSI4IiBjeT0iMiIgcng9IjgiIHJ5PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMC4zNjEgLTAuMTgyKSIvPg0KICAgICAgPGVsbGlwc2UgaWQ9IuakreWchl82NTUiIGRhdGEtbmFtZT0i5qSt5ZyGIDY1NSIgY2xhc3M9ImNscy0yIiBjeD0iMyIgY3k9IjAuNSIgcng9IjMiIHJ5PSIwLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuNjM5IDAuODE4KSIvPg0KICAgIDwvZz4NCiAgICA8cGF0aCBpZD0i6Lev5b6EXzQ3MjIiIGRhdGEtbmFtZT0i6Lev5b6EIDQ3MjIiIGNsYXNzPSJjbHMtMyIgZD0iTTEzNS41NCwxMDIuMDg5Yy0xLjA0NywwLTcuNTQtNS4wNTEtNy41NC05LjIxNmE3LjU0LDcuNTQsMCwxLDEsMTUuMDgsMGMwLDQuMTY0LTYuNDkzLDkuMjE1LTcuNTQsOS4yMTVabTAtNi45MTJhMi4zLDIuMywwLDEsMC0yLjMtMi4zQTIuMywyLjMsMCwwLDAsMTM1LjU0LDk1LjE3N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwNjcuMDk5IDUxOC40NTgpIi8+DQogIDwvZz4NCjwvc3ZnPg0K";
};

// 百度地图中散点图片2
const greenBase = () => {
  return "image://data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIzNS4yMDgiIHZpZXdCb3g9IjAgMCAyOCAzNS4yMDgiPg0KICA8ZGVmcz4NCiAgICA8c3R5bGU+DQogICAgICAuY2xzLTEsIC5jbHMtMiwgLmNscy0zIHsNCiAgICAgICAgZmlsbDogIzFiZjZmODsNCiAgICAgIH0NCg0KICAgICAgLmNscy0xIHsNCiAgICAgICAgb3BhY2l0eTogMC4yOw0KICAgICAgfQ0KDQogICAgICAuY2xzLTIgew0KICAgICAgICBvcGFjaXR5OiAwLjU7DQogICAgICB9DQogICAgPC9zdHlsZT4NCiAgPC9kZWZzPg0KICA8ZyBpZD0i57uEXzM5MDciIGRhdGEtbmFtZT0i57uEIDM5MDciIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTk1IC02MDMuNzkyKSI+DQogICAgPGcgaWQ9Iue7hF8zOTA4IiBkYXRhLW5hbWU9Iue7hCAzOTA4Ij4NCiAgICAgIDxlbGxpcHNlIGlkPSLmpK3lnIZfNjU2IiBkYXRhLW5hbWU9IuakreWchiA2NTYiIGNsYXNzPSJjbHMtMSIgY3g9IjE0IiBjeT0iMy41IiByeD0iMTQiIHJ5PSIzLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExOTUgNjMyKSIvPg0KICAgICAgPGVsbGlwc2UgaWQ9IuakreWchl82NTUiIGRhdGEtbmFtZT0i5qSt5ZyGIDY1NSIgY2xhc3M9ImNscy0yIiBjeD0iNiIgY3k9IjEuNSIgcng9IjYiIHJ5PSIxLjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEyMDMgNjMzKSIvPg0KICAgIDwvZz4NCiAgICA8cGF0aCBpZD0i6Lev5b6EXzQ3MjIiIGRhdGEtbmFtZT0i6Lev5b6EIDQ3MjIiIGNsYXNzPSJjbHMtMyIgZD0iTTE0MS44MTksMTE2LjA0MmMtMS45MTksMC0xMy44MTktOS4yNTgtMTMuODE5LTE2Ljg5YTEzLjgxOSwxMy44MTksMCwxLDEsMjcuNjM3LDBjMCw3LjYzMi0xMS45LDE2Ljg5LTEzLjgxOSwxNi44OVptMC0xMi42NjdhNC4yMjIsNC4yMjIsMCwxLDAtNC4yMjItNC4yMjJBNC4yMjIsNC4yMjIsMCwwLDAsMTQxLjgxOSwxMDMuMzc0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA2Ny4xODIgNTE4LjQ1OCkiLz4NCiAgPC9nPg0KPC9zdmc+DQo=";
};

// 词云图
const picture = () => {
  return "data:image/png;base64,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";
};

export default {
  baiduMapStyle1,
  baiduMapStyle2,
  blueBase,
  greenBase,
  picture,
};
